module.exports = __webpack_public_path__ + "static/media/icon-umbrella.80a3462c.svg";